import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'mvtNearbyPlaces',
    inject: ['$eventBus'],
    data() {
        return {
            initialed: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getPlaces']),
    },
    methods: {
        ...mapActions('glb', ['searchPlaces']),
    },

    mounted() {
        if (this.glb.geo && this.glb.geo.lat && this.glb.geo.lng) {
            this.searchPlaces({
                lat: this.glb.geo.lat,
                lng: this.glb.geo.lng,
            });
        }
    },
};
